import { render, staticRenderFns } from "./PermissionsGroup.vue?vue&type=template&id=2f983e06&"
import script from "./PermissionsGroup.vue?vue&type=script&lang=ts&"
export * from "./PermissionsGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports